import { render } from "./PrivateFileOverlay.vue?vue&type=template&id=35724762"
import script from "./PrivateFileOverlay.vue?vue&type=script&lang=js"
export * from "./PrivateFileOverlay.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__